import { createSlice } from "@reduxjs/toolkit";

export const alertDialog = createSlice({
  name: "alert-dialog",
  initialState: {
    value: {
      active: false
    }
  },
  reducers: {
    setDialog(state, {payload}) {
        state.value.active = payload
    }
  },
});

export const { setDialog } = alertDialog.actions;
export default alertDialog.reducer;
